export default "__VITE_ASSET__BTT5q7ai__"